import React, { useContext, useEffect, useState } from "react";
import { yupResolver } from '@hookform/resolvers/yup';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AximTooltip from "components/AximTooltip";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    FormGroup,
    FormControlLabel,
    Checkbox,
    FormControl,
    IconButton
} from "@mui/material";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Utils } from "common/Utils";
import ConfirmDialog from "components/Content/Modal/ConfirmDialog";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import TableAllData from "components/Content/CustomTable/TableAllData";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import LoaderAnimation from "pages/LoaderAnimation";
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function HourTypeSettings ({ refresh, isAdmin, isReadonly}) {
    const { companyId, error } = useContext(PrivateRoutesContext);

    const validationSchema = Yup.object().shape({
        hourTypeName: Yup.string().required('Hour Type Name is required')
            .max(50, 'Contract Name must not exceed 50 characters'),
        typeOfHoursID: Yup.string().required('Type of houris required')
    });
    const {
        register,
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const [typeOfHours, setTypeOfHours] = React.useState([])
    const [savingData, setSavingData] = React.useState(false)
    const newHourType =
    {
        "hourTypeID": Utils.emptyGuid(),
        "fringeGroupID": Utils.emptyGuid(),
        "hourTypeName": "",
        "hourTypeCode": null,
        "typeOfHoursName": null,
        "typeOfHoursID": null,
        "isPaid": false,
        "isWork": false,
        "isContract": false,
        "isProrated": false
    };
    const [hourType, setHourType] = React.useState(newHourType);

    const onSubmit = data => {

        handleSaveHourType()
    };
    const [checkingData, setCheckingData] = useState(true);

    const [openModal, setOpen] = useState(false);
    const [columnsArray, setColumnsArray] = useState([]);
    const [fetchedData, setFetchedData] = useState([]);

    const [doShowConfirm, setDoShowConfirm] = useState(false);
    const [confirmCloseAction, setConfirmCloseAction] = useState(null);
    const [confirmTitle, setConfirmTitle] = useState('');
    const [confirmText, setConfirmText] = useState('');
    const [confirmButtonsDisabled, setConfirmButtonsDiabled] = useState(false);
    const fetchTypeOfHours = (event) => {
        setCheckingData(true);
        apiGet(apiUrls.getTypeOfHours())
            .then((response) => {
                // console.log('type of hours')
                // console.dir(response)
                setTypeOfHours(response.data);
            })
            .catch(function (error) {
            })
            .then(function () {
                // always executed
                setCheckingData(false);
            });
    };
    const fetchHourTypes = (event) => {
        setCheckingData(true);
        apiGet(apiUrls.getCompanyHourTypes(companyId))
            .then((response) => {
                // console.log('fetch ht')
                // console.dir(response)
                setFetchedData(response.data);
            })
            .catch(function (error) {
                // console.log("THIS IS ERROR", error);
                setColumnsArray([]);
                setFetchedData([]);
            })
            .then(function () {
                // always executed
                setCheckingData(false);
            });
    };
    const handleEdit = (hourType) => {
        setOpen(true);
        // console.log('edit')
        // console.log(hourType)
        setHourType(hourType)
        reset(hourType)
    }

    const handleClose = () => {
        setOpen(false);
        //setAnchorEl(null);
    };

    const showAddModal = () => {
        setHourType(newHourType);
        setOpen(true);
        reset(newHourType)
    };

    const promptDelete = (cell) => {
        setConfirmCloseAction(() => (result) => removeHourType(result, cell));
        setConfirmTitle('Remove Hour Type');
        setConfirmText(`Are you sure you would like to remove the ${cell.hourTypeName} hour type?`);
        setDoShowConfirm(true);
    }

    const removeHourType = (isConfirmed, cell) => {
        if (isConfirmed) {
            setConfirmButtonsDiabled(true);

            apiPost(apiUrls.removeHourType(companyId, cell.hourTypeID)).then(
                (response) => {
                    fetchHourTypes()
                }
            ).catch(
                (response) => {
                    error.setTitle("An Error Occurred");
                    error.setText("An Error occurred loading templates.");
                    error.setDoShowError(true);
                    setCheckingData(false);
                }
            )
                .finally(() => {
                    setConfirmButtonsDiabled(false);
                    setDoShowConfirm(false);
                });
        }
        else {
            setDoShowConfirm(false);
        }
    }

    const handleConfirmClose = (result) => {
        confirmCloseAction(result);
    }

    const handleHourTypeChange = (propName, propValue) => {
        let obj = { ...hourType }
        obj[propName] = propValue
        if (propName == 'hourTypeName') {
            obj['hourTypeCode'] = propValue.replaceAll(' ', '_').substring(0, 50)
        }
        setHourType(obj);
        setValue(propName, propValue, { shouldValidate: true })
    };
    // const handleHourTypeChange = _.debounce((propName, propValue) => {
    //     let obj = { ...hourType }
    //     obj[propName] = propValue
    //     if(propName=='hourTypeName'){
    //         obj['hourTypeCode'] = propValue.replaceAll(' ','_').substring(0, 50)
    //     }
    //     setHourType(obj);
    // }, 200);

    const handleSaveHourType = () => {
        setSavingData(true)
        let companyId = localStorage.getItem(`selectedCompanyId`);
        apiPost(apiUrls.postHourType(companyId), hourType)
            .then((response) => {
                console.log('post ht')
                console.dir(response)
                fetchHourTypes()
                setOpen(false)

            })
            .catch(function (error) {
            })
            .then(function () {
                setSavingData(false)
            });
    };

    useEffect(() => {
        var actionColumn = 
            {
                Header: "Action",
                accessor: (cell) => (
                    <>
                        <AximTooltip title="Edit Hour Type">
                            <IconButton
                                color="primary" aria-label="Edit Hour Type"
                                component="span"
                                onClick={() => handleEdit(cell)}
                            >
                                <EditOutlinedIcon />
                            </IconButton>
                        </AximTooltip>
                        <AximTooltip title="Remove Hour Type">
                            <IconButton
                                color="primary" aria-label="Delete Hour Type"
                                component="span"
                                onClick={() => promptDelete(cell)}
                            >
                                <DeleteOutlinedIcon />
                            </IconButton>
                        </AximTooltip>
                    </>),
                disableFilters: true,
            };

        if (isReadonly && !isAdmin) {
            setColumnsArray(columns);
        }
        else {
            setColumnsArray([actionColumn, ...columns]);
        }
    }, [isReadonly, isAdmin, refresh]);

    useEffect(() => {
        fetchTypeOfHours()
        if ( refresh > 0) {
            fetchHourTypes()
        }
    }, [refresh]);
    
    let columns = [
        {
            Header: "Type Of Hour",
            accessor: "typeOfHoursName",
        },
        {
            Header: "Hour Type name",
            accessor: "hourTypeName",
        },
        {
            Header: "Is Paid Hour?",
            accessor: (cell) => (cell.isPaid ? "Yes" : "No"),
        },
        {
            Header: "Is Work Hour?",
            accessor: (cell) => (cell.isWork ? "Yes" : "No"),
        },
        {
            Header: "Is Contract Hour?",
            accessor: (cell) => (cell.isContract ? "Yes" : "No"),
        }
    ];

    const options = {
        filter: true,
        filterType: "dropdown",
        responsive: "standard",
        viewColumns: true,
        download: false,
        print: false,
        textLabels: {
            body: {
                noMatch:
                    fetchedData !== undefined ? (
                        <LoaderAnimation />
                    ) : (
                        "Sorry, there is no data to show"
                    ),
            },
        },
        searchProps: { variant: "standard" }
    };

    return (
        <>
            {/* Add Hour Type MODAL */}
            <Dialog
                open={openModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                    {(hourType.hourTypeID == Utils.emptyGuid() ? "Add New Hour Type" : "Edit Hour Type")}
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div>
                            <TextField
                                {...register('hourTypeName')}
                                label="Hour Type Name"
                                InputLabelProps={{ shrink: true }}
                                required
                                defaultValue={hourType.hourTypeName}
                                id="hourTypeName"
                                name="hourTypeName"
                                value={hourType.hourTypeName}
                                variant="standard"
                                onChange={(e) => handleHourTypeChange('hourTypeName', e.target.value)}
                                error={errors.hourTypeName ? true : false}
                                helperText={errors.hourTypeName?.message}
                            />
                            <FormControl sx={{ m: 1, minWidth: 200 }}>
                                <InputLabel id="type-of-hour-select-label">Type Of Hour</InputLabel>
                                <Select
                                    required
                                    {...register('typeOfHoursID')}
                                    id="typeOfHoursID"
                                    name="typeOfHoursID"
                                    value={hourType.typeOfHoursID ?? ''}
                                    label="Type Of Hour"
                                    variant="standard"
                                    onChange={(e) => handleHourTypeChange('typeOfHoursID', e.target.value)}
                                    error={errors.typeOfHoursID ? true : false}
                                >
                                    {typeOfHours.map((th, i) => <MenuItem value={th.typeOfHoursID} key={i}>{th.typeOfHoursName}</MenuItem>)}

                                </Select>
                            </FormControl>
                        </div>
                        <div>
                            <FormGroup>
                                <FormControlLabel control={<Checkbox checked={hourType.isPaid} />} label="Is Paid Hour"
                                    onChange={(e) => handleHourTypeChange('isPaid', e.target.checked)} />
                                <FormControlLabel control={<Checkbox checked={hourType.isWork} />} label="Is Work Hour"
                                    onChange={(e) => handleHourTypeChange('isWork', e.target.checked)} />
                                <FormControlLabel control={<Checkbox checked={hourType.isContract} />} label="Is Contract Hour"
                                    onChange={(e) => handleHourTypeChange('isContract', e.target.checked)} />
                            </FormGroup>
                        </div>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button
                        variant="outlined"
                        onClick={handleSubmit(onSubmit)}
                        disabled={savingData}
                    >
                        {(savingData ? "Saving" : "Save")}
                    </Button>
                    <Button onClick={handleClose} variant="outlined">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <TableAllData
                className={TableStyle.TimeSheetsWrapper}
                columns={columnsArray}
                data={fetchedData}
                isLoading={checkingData}
                headerContents={isReadonly && !isAdmin ? null :
                    <>
                        <AximTooltip title="Add New Hour Type" disableFocusListener>
                            <IconButton
                                color="primary"
                                aria-label="Add New Hour Type"
                                component="span"
                                onClick={showAddModal}
                            >
                                <AddCircleOutlineOutlinedIcon />
                            </IconButton>
                        </AximTooltip>
                    </>}
            />

            <ConfirmDialog
                doShowConfirm={doShowConfirm}
                handleClose={handleConfirmClose}
                confirmTitle={confirmTitle}
                confirmText={confirmText}
                buttonsDisabled={confirmButtonsDisabled} />
        </>
    )
}